/*************************************************************************
 * 
 * KLEAREXPRESS CONFIDENTIAL
 * __________________
 * 
 *  Copyright (c) 2018 - 2018 KlearExpress Corporation.
 *  All Rights Reserved.
 * 
 * NOTICE:  All information contained herein is, and remains
 * the property of KlearExpress Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KlearExpress Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KlearExpress Corporation.
 */


import React, { Component } from 'react';
import '../styles/css/ach-payment.css';
import { Button, Input, Segment, Form, Container, Header, Checkbox, Popup, Grid, Icon } from 'semantic-ui-react';
import PaymentData from './payment-data';

class CreditCardForm extends Component {
  constructor() {
    super();
    this.state = {
      submitted: false,
      values: []
    }
  }

  handleChange = (e, { name, value }) => this.setState({ [name]: value })

  selectType = (e) => {
    this.setState({ value: e.target.getAttribute('name') })
  }

  handleSubmit = () => {
    const submitted = this.state
    this.props.submit()
    this.setState({ submitted: true })
  }

  render() {
    const { handleChange, paymentData } = this.props
    const style = {
      container: {
        borderRadius: 0,
      }
    }

    return (
      <div>
        {
          this.state.submitted === false ?
            <Segment padded='very' className="signup-form ach-payment-container" raised>
              <Form>
                <Header as='h1'>Payment Information</Header>
                <Header as='h3' className="payment-label">CREDIT CARD</Header>
                <Container className="add-payment-container">
                  <Form.Field>
                    <label className="ach-payment-label">NAME ON CARD</label>
                    <Input placeholder='Enter Account Holder Name'
                      name="cardHolder"
                      // paymentData, cardHolder, cardNumber, expDate, CVV, paymentType
                      // value={this.props.paymentData[0]}
                      className="ach-payment-input"
                      onChange={handleChange}
                    />
                    <label className="ach-payment-label">CARD NUMBER</label>
                    <Input placeholder='Enter Card Number'
                      name="cardNumber"
                      // value={username}
                      className="ach-payment-input"
                      onChange={handleChange}
                    />
                    <label className="ach-payment-label">EXP DATE</label>
                    <Input placeholder='Enter Expiration Date'
                      name="expDate"
                      // value={password}
                      className="ach-payment-input"
                      onChange={handleChange}
                    />
                    <label className="ach-payment-label">CVV</label>
                    <Input placeholder='CVV'
                      name="CVV"
                      // value={email}
                      className="ach-payment-input"
                      onChange={handleChange}
                    />
                    <br />
                  </Form.Field>
                  <br />
                  <center>
                    <Icon onClick={this.props.backToPaymentPage} name="add" circular color="blue" className="add-ach-payment" size='big' />
                    {/* <Popup
                      // open={open}
                      trigger={<Icon onClick={this.toggle} name="add" circular color="blue" className="add-ach-payment" size='big' />}
                      inverted
                      flowing hoverable content={<Checkbox />} size='tiny' position="top center" className="ach-payment-popup" style={style.contiainer}
                    >
                      <Grid divided columns={1} className="ach-payment-popup-grid">
                        <Grid.Column>
                          <Form.Group>
                            <p onClick={this.selectType.bind(this)} name="ach" className="ach-payment-popup-p"><Icon name="money bill alternate outline" />ACH</p>
                          </Form.Group>
                          <Form.Group>
                            <p onClick={this.selectType.bind(this)} name="credit card" className="ach-payment-popup-p"><Icon name="credit card outline" />Credit Card</p>
                          </Form.Group>
                          <Form.Group>
                            <p onClick={this.selectType.bind(this)} name="paypal" className="ach-payment-popup-p"><Icon name="cc paypal" />PayPal</p>
                          </Form.Group>
                        </Grid.Column>
                      </Grid>
                    </Popup> */}
                  </center>
                </Container>
              </Form>
              <div className="payment-buttonRow">
                <Button type='submit' className="payment-cancel">CANCEL</Button>
                <Button type='submit' className="payment-skip">SKIP THIS</Button>
                <Button onClick={this.handleSubmit.bind(this)} type='submit' className="payment-save" color="twitter">SAVE & NEXT</Button>
              </div>
            </Segment>
            :
            this.state.submitted === true ?
              <PaymentData paymentType={this.props.paymentType} backToPaymentPage={this.props.backToPaymentPage} selectType={this.selectType.bind(this)} data={this.props.paymentData} count={this.props.count} />
              :
              null
        }
      </div>
    );
  }
}

export default CreditCardForm;